// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetAuditSummaryCriteria = () => ({
    type: actions.RESET_AUDIT_SUMMARY_REPORT_CRITERIA
});

export const selectAuditSummaryCriteria = (attribute, value) => ({
    attribute,
    type: actions.SELECT_AUDIT_SUMMARY_REPORT_CRITERIA,
    value
});

export const updateAuditSummaryTerritory = (territory, isSelected) => ({
    isSelected,
    territory,
    type: actions.SELECT_AUDIT_SUMMARY_REPORT_TERRITORY
});

export const selectAllTerritories = territories => ({
    territories,
    type: actions.SELECT_ALL_AUDIT_SUMMARY_REPORT_TERRITORIES
});



// WEBPACK FOOTER //
// ./src/reports/audit-summary/action-creators/criteria.js